<script setup lang="ts">
import {computed} from 'vue';
import VChart from 'vue-echarts';
import type {EChartsOption, SeriesOption} from 'echarts';
import '@/base/echarts.js';
import {formatMln, KLEUR_LIJN, KLEUR_TARGET, TOTAAL_LABEL, Waterfall} from 'common';

const KLEUR_TOTAAL: string = '#23272d';

const props = defineProps<{
    waterfall: Waterfall;
}>();

const option = computed<EChartsOption>(() => {
    const labels: string[] = [...props.waterfall.stappen.map(s => s.status), TOTAAL_LABEL];
    const basis: number[]  = [];
    const waarde: number[] = [];
    let lopend: number     = 0;
    for (const stap of props.waterfall.stappen) {
        basis.push(lopend);
        waarde.push(stap.bedrag);
        lopend += stap.bedrag;
    }
    basis.push(0);
    waarde.push(props.waterfall.totaal);
    return {
        grid   : {left: 8, right: 8, top: 32, bottom: 8, containLabel: true},
        tooltip: {trigger  : 'axis', formatter: (params: unknown) => {
            const p = (params as {name: string; seriesName: string; value: number}[]).find(x => x.seriesName === 'bedrag');
            return p === undefined ? '' : `${p.name}: ${formatMln(p.value)}`;
        }},
        xAxis : {type: 'category', data: labels, axisLabel: {interval: 0}},
        yAxis : {type: 'value', axisLabel: {formatter: (v: number) => formatMln(v)}},
        series: [
            {type: 'bar', name: 'basis', stack: 'w', data: basis, itemStyle: {color: 'transparent'}, tooltip: {show: false}} as unknown as SeriesOption,
            {
                type    : 'bar',
                name    : 'bedrag',
                stack   : 'w',
                data    : waarde.map((v, i) => ({value: v, itemStyle: {color: i === waarde.length - 1 ? KLEUR_TOTAAL : KLEUR_LIJN}})),
                label   : {show: true, position: 'top', formatter: (p: {value: number}) => formatMln(p.value)},
                markLine: {silent: true, symbol: 'none', data: [{yAxis: props.waterfall.beschikbaar, lineStyle: {type: 'dotted', color: KLEUR_TARGET}, label: {formatter: `Beschikbaar budget: ${formatMln(props.waterfall.beschikbaar)}`, position: 'insideStartTop'}}]},
            } as unknown as SeriesOption,
        ],
    };
});
</script>

<template>
    <v-chart :option="option" autoresize :style="{height: '320px', width: '100%'}"/>
</template>
